<template>
  <!-- 承运商报价 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div
      class="glo_btnList"
      ref="btnList"
    >
      <div class="glo_btnList_left">
        <span>{{carrierName}}</span>
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="clickReturnList"
        >返回</el-button>
        <el-button
          class="glo_btnItems"
          @click="clickAdd"
        >新建报价</el-button>
        <el-button
          class="glo_btnItems"
          @click="clickEnable"
        >启用</el-button>
        <el-button
          class="glo_btnItems"
          @click="clickDisable"
        >禁用</el-button>
        <el-button
          class="glo_btnItems"
          @click="clickDels"
        >批量删除</el-button>
        <el-dropdown
          class="topDropDown"
          @command="topCommandBtns"
        >
          <el-button type="primary">
            更多操作
            <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <!-- :formData="queryData" -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <div class="glo_Table">
      <el-table
        :height="tableHeigth"
        header-align="center"
        ref="mytable"
        @row-click="rowclick"
        :data="tableData"
        border
        stripe
        :highlight-current-row="true"
        show-summary
        :summary-method="getSummaries"
        @selection-change="handleSelectionChange"
      >
        <el-table-column
          fixed="left"
          align="center"
          label="序号"
          type="index"
          width="60"
        ></el-table-column>
        <el-table-column
          fixed="left"
          align="center"
          type="selection"
          width="60"
        ></el-table-column>
        <template v-for="(item, index) in myTableHeard">
          <el-table-column
            :key="index"
            :label="item.name"
            :prop="item.field"
            align="center"
            sortable
            :show-overflow-tooltip="true"
            :min-width="item.width"
            :data-isTotal="item.isTotal"
            v-if="item && item.isShow"
          ></el-table-column>
        </template>
        <el-table-column
          fixed="right"
          label="操作"
          min-width="180px"
        >
          <template slot-scope="scope">
            <div class="tabRightBtns">
              <el-button
                class="rbtns"
                @click.stop="clickSettings(scope.row)"
              >设置</el-button>
              <el-button
                class="rbtns"
                @click.stop="clickAdd(scope.row)"
              >修改</el-button>
              <el-button
                class="rbtns"
                @click.stop="clickDels(scope.row)"
              >删除</el-button>
              <!-- 如果按钮超过4个就要用下面这种下拉的样式 -->
              <!-- <el-dropdown
                class="rbtns"
                @command="handleCommandBtns($event, scope.row)"
              >
                <el-button type="primary">
                  更多操作<i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="a">详情</el-dropdown-item>
                  <el-dropdown-item command="b">外发录入</el-dropdown-item>
                  <el-dropdown-item command="c">改运单号</el-dropdown-item>
                  <el-dropdown-item command="d">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>-->
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- 分页 -->
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 新增修改 -->
    <myDialog
      :diaWidth="diaWidthDispatch"
      :dialogTitle="dialogTitleDispatch"
      :isShowDialog="isShowDialogDispatch"
      @handleCloseDia="handleCloseDiaDispatch"
      @diaCancelBtn="handleCloseDiaDispatch"
      @diaConfirmBtn="diaConfirmBtnDispatch"
    >
      <div
        class="formbox"
        v-if="isShowDialogDispatch"
      >
        <el-form
          class="glo_formBox"
          label-width="120px"
        >
          <div class="formBox_item">
            <el-form-item
              label="报价名称:"
              required
            >
              <el-input
                v-model="dialogFormDispatch.channelName"
                placeholder="请输入"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="计费方式:"
              required
            >
              <el-select
                v-model="dialogFormDispatch.formulaBillingWeightIds"
                placeholder="请选择"
                multiple
                collapse-tags
                clearable
              >
                <el-option
                  v-for="item in out_going_billing_method_list"
                  :key="item.formulaBillingWeightId"
                  :label="item.formulaBillingWeightName"
                  :value="`${String(item.formulaBillingWeightId)}`"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <el-form-item
            class="textArea"
            style="width: 100%"
            label="备注:"
          >
            <el-input
              type="textarea"
              v-model="dialogFormDispatch.comment"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
    <!-- 导出插件 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    ></exportCompoent>
  </div>
</template>
<script>
import tableList from '@/pages/tableList.js'
import sorttable from '@/components/sortTemplate.vue' //自定义排序表头
import paging from '@/components/pagings.vue' //分页组件
import queryBtns from '@/components/queryBtns.vue'
import queryCondition from '@/components/queryCondition.vue'
import myDialog from '@/components/Dialog.vue'
import exportjs from '@/assets/js/Mixins/exportDT.js' //导出的公共js
export default {
  mixins: [tableList, exportjs],
  inject: ['reload'],
  components: {
    sorttable,
    paging,
    queryBtns,
    queryCondition,
    myDialog,
  },
  data() {
    return {
      //=======================导出相关 开始 =======================
      dialogForm_dc: {
        pageStart: 1,
        pageTotal: '',
        fileName: '承运商报价', //导出时默认文件名
        apiName: '/v1/common/query/runPageReport', //导出的数据列表接口名(动态列表都是这个)
        EpType: 'bdd', //dd==等待下载完成,bdd==不等待完成
        apiType: 'POST', //导出当前列表的请求方式
        isJson: 1, // 导出当前列表的请求头是否json
      },
      //=======================导出相关 结束 =======================
      pageGroupName: 'Customers_NVOCCCarrierQuotation', //  页面标识
      reportFiledsNumber: 'admin_carrier_channel_list', // 动态 条件、表头

      isShowDialogDispatch: false,
      dialogTitleDispatch: '新增',
      diaWidthDispatch: '60%',
      dialogFormDispatch: {
        channelName: '',
        formulaBillingWeightIds: [],
        comment: '',
      },
      carrierNumber: '',
      carrierId: '',
      carrierName: '',
      out_going_billing_method_list: [],
    }
  },
  mounted() {
    this.formula_billing_weight_down_list() //计费方式
  },
  activated() {
    const { carrierId, carrierNumber, carrierName } = this.$route.query
    if (carrierId) {
      this.carrierNumber = carrierNumber
      this.carrierId = carrierId
      this.carrierName = carrierName
      this.initTable()
    }
  },
  watch: {},
  methods: {
    clickSettings({ channelId, channelName }) {
      this.$router.push({
        path: '/Customers/NVOCCLineQuotation',
        query: {
          channelId,
          channelName,
          carrierId: this.carrierId,
          carrierName: this.carrierName,
          carrierNumber: this.carrierNumber,
        },
      })
    },
    clickReturnList() {
      this.$router.push({
        path: '/Customers/NVOCC',
      })
    },
    getData() {
      let conditionReqs = []
      let F_config = this.$refs.queryForm.F_config
      F_config.forEach((element) => {
        let {
          textBoxType,
          conditonKey,
          dropdownSubmitField,
          conditonVal,
          timeType,
          timeChilds,
          startTime_a,
          endTime_a,
        } = element
        switch (textBoxType) {
          case 'input':
            if (conditonKey == 'carrierId') {
              conditionReqs.push({
                conditonKey,
                conditonVal: this.carrierId,
              })
            } else {
              conditionReqs.push({
                conditonKey,
                conditonVal,
              })
            }
            break
          case 'input_more':
            conditionReqs.push({
              conditonKey,
              conditonVal: (conditonVal && conditonVal.split("/")) || [],
            })
            break
          case 'select':
            conditionReqs.push({
              conditonKey: dropdownSubmitField || conditonKey,
              conditonVal,
            })
            break
          case 'datetime':
            let curs = timeChilds[timeType]
            curs &&
              curs.children.forEach((element, index) => {
                let endTime_agg = endTime_a ? `${endTime_a} 23:59:59` : ''
                let startTime_agg = startTime_a ? `${startTime_a} 00:00:00` : ''
                conditionReqs.push({
                  conditonKey: element.conditonKey,
                  conditonVal: index == 1 ? endTime_agg : startTime_agg,
                })
              })
            break
          default:
            break
        }
      })
      let params = {
        conditionReqs,
        pageStart: this.pageStart,
        pageTotal: this.pageTotal,
        number: this.reportFiledsNumber,
      }
      this.$API.runPageReport(params).then((res) => {
        if (res.data.status === 'success') {
          let datas = res.data.result.datas || {}
          this.className = datas.className || ''
          this.tableData = datas.data || []
          this.pageCount = datas.pageCount || 0
          this.$nextTick(() => {
            this.fetTableHeight()
          })
        } else {
          this.$message.error(`${res.data.message}---综合查询列表`)
        }
      })
    },
    async clickAdd(row) {
      if (row.channelId) {
        this.dialogTitleDispatch = '修改报价'
        let formulaBillingWeightIds = []
        await this.$API
          .runPageReportDetails({
            conditionReqs: [
              {
                conditonKey: 'channelId',
                conditonVal: row.channelId,
              },
            ],
            number: 'admin_carrier_channel_detail_formula_list',
          })
          .then((res) => {
            if (res.data.status === 'success') {
              let datas = res.data.result.datas || []
              formulaBillingWeightIds = datas.map((n) => {
                return n.formulaBillingWeightId
              })
            } else {
              this_.$message.error(`${res.data.message}---综合查询列表`)
            }
          })
        this.dialogFormDispatch = {
          channelId: row.channelId,
          channelName: row.channelName,
          formulaBillingWeightIds,
          comment: row.comment,
        }
      } else {
        this.dialogTitleDispatch = '新增报价'
      }
      this.isShowDialogDispatch = true
    },
    handleCloseDiaDispatch() {
      this.isShowDialogDispatch = false
      this.dialogFormDispatch = {
        channelName: '',
        formulaBillingWeightIds: [],
        comment: '',
      }
    },
    //  弹窗确认保存事件
    diaConfirmBtnDispatch() {
      const { channelId, channelName, formulaBillingWeightIds } =
        this.dialogFormDispatch
      console.log({ channelId, channelName, formulaBillingWeightIds })
      if (!channelName) {
        this.$message.error('请输入报价名称')
        return false
      }
      if (!formulaBillingWeightIds.length) {
        this.$message.error('请选择计费方式')
        return false
      }
      let params = {
        carrierId: this.carrierId,
        ...this.dialogFormDispatch,
      }
      if (channelId) {
        this.$API.updateCarrierOffer(params).then((res) => {
          this.$message.success(res.data.message || '操作成功')
          this.isShowDialogDispatch = false
          this.getData()
        })
      } else {
        this.$API.addCarrierOffer(params).then((res) => {
          this.$message.success(res.data.message || '操作成功')
          this.isShowDialogDispatch = false
          this.getData()
        })
      }
    },
    clickDels(data) {
      if (data) this.selectTableData = [data]
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      }
      let channelIds = []
      this.selectTableData.forEach((item) => {
        channelIds.push(item.channelId)
      })
      this.$confirm('确定要删除所选数据吗? 请谨慎操作', '提示:')
        .then((res) => {
          this.$API.delCarrierOffer({ channelIds }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch((err) => {})
    },
    clickEnable() {
      let channelIds = []
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      }
      this.selectTableData.forEach((item) => {
        channelIds.push(item.channelId)
      })
      this.$confirm('确定要启用所选数据吗? 请谨慎操作', '提示:')
        .then((res) => {
          this.$API.startCarrierOffer({ channelIds }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch((err) => {})
    },
    clickDisable() {
      let channelIds = []
      if (this.selectTableData.length < 1) {
        this.$message.error('请至少选择一条数据进行操作')
        return false
      }
      this.selectTableData.forEach((item) => {
        channelIds.push(item.channelId)
      })
      this.$confirm('确定要禁用所选数据吗? 请谨慎操作', '提示:')
        .then((res) => {
          this.$API.stopCarrierOffer({ channelIds }).then((res) => {
            this.$message.success(res.data.message || '操作成功')
            this.getData()
          })
        })
        .catch((err) => {})
    },
    formula_billing_weight_down_list(type) {
      this.$API
        .runPageReportDetails({
          number: 'formula_billing_weight_down_list',
        })
        .then((res) => {
          if (res.data.status === 'success') {
            let datas = res.data.result.datas || []
            this.out_going_billing_method_list = datas
          } else {
            this_.$message.error(`${res.data.message}---综合查询列表`)
          }
        })
    },
  },
}
</script>
<style scoped lang="less">
.textArea {
  height: auto !important;
}
.formBox_item {
  width: 100%;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  .el-form-item {
    width: 48%;
  }
}
</style>